import { observable, action, runInAction } from 'mobx';
import { isEmpty, cloneDeep } from 'lodash';
import { round } from 'mathjs';

import moStore, { toggleValue } from '@store/index';
import EffectService from '@service/effect';

const moDistribution = observable({
  empty: false,
  timeActive: <number | string>'',
  list: <any[]>[],
  maxValue: 0,
  totalValue: 0,
  declineCount: 0,
  declineRate: 0,
  increaseCount: 0,
  increaseRate: 0,
});

const distributionInit = action((res: any, loading = false) => {
  if (isEmpty(res)) {
    moDistribution.empty = true;
    if (loading) toggleValue('isLoading', false);
    return;
  }
  moDistribution.empty = false;
  // console.log('人员配置 变化率分布 -- ', res);
  let max = 0;
  let total = 0;

  res.distribution.map((item: any) => {
    if (item.count > max) max = item.count;
    total += item.count;
  });
  let empty = false;
  res.distribution?.map((item: any) => {
    if (item.count > 0) empty = true;
  });

  runInAction(() => {
    if (empty) moDistribution.list = res.distribution;
    else moDistribution.list = [];
    moDistribution.maxValue = max;
    moDistribution.totalValue = total;
    moDistribution.declineCount = res.decline_count;
    moDistribution.declineRate = res.decline_rate;
    moDistribution.increaseCount = res.increase_count;
    moDistribution.increaseRate = res.increase_rate;
    if (loading) toggleValue('isLoading', false);
  });
});

const timeTabChange = action(async (value: number | string, loading = false) => {
  moDistribution.timeActive = value;
  localStorage.setItem('settleRatioYear', value.toString());

  if (!loading) {
    toggleValue('isLoading', true);
    const res: any = await EffectService.settleRatio({
      year: moDistribution.timeActive,
    });
    distributionInit(res, true);
  }
});

export default moDistribution;
export {
  distributionInit, timeTabChange,
};
